import { useLocation } from "react-router";
import { useShopfrontSelector } from "../../_Bootstrap/hooks";

export const useShowMenu = (): boolean => {
    const noRegister = useShopfrontSelector(state => !state.location.register?.id);

    const location = useLocation();

    return location.pathname === "/" && noRegister;
};
